var convert = require('./convert'),
    func = convert('values', require('../values'), require('./_falseOptions'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ../~/lodash/fp/values.js
// module id = 632
// module chunks = 0